import { CalendarToday as CalendarTodayIcon } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import type { MbscCalendarEvent } from "@mobiscroll/react";
import { ScheduleInfoPopperShell } from "./ScheduleInfoPopperShell.partial";

type P = {
  popperId: string | undefined;
  popperOpen: boolean;
  anchorEl: HTMLElement | null;
  holidaySchedule: MbscCalendarEvent;
  onClose: () => void;
};

export function ScheduleHolidayInfoPopper({
  popperId,
  popperOpen,
  anchorEl,
  holidaySchedule,
  onClose
}: Readonly<P>) {
  return (
    <ScheduleInfoPopperShell
      anchorEl={anchorEl}
      backdropTestId="holiday-popper-backdrop"
      onClose={onClose}
      paperMaxWidth={300}
      popperId={popperId}
      popperOpen={popperOpen}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <CalendarTodayIcon
          sx={theme => ({
            color: theme.palette.primary.main,
            fontSize: "1.2rem"
          })}
        />
        <Typography
          variant="body1"
          sx={theme => ({
            color: theme.palette.text.primary,
            fontWeight: 500,
            lineHeight: 1.4
          })}
        >
          {holidaySchedule.title}
        </Typography>
      </Box>
    </ScheduleInfoPopperShell>
  );
}
